import HotelsSearchForm from './src/HotelsSearchForm';
import MultiroomWarning from './src/blocks/MultiroomWarning';
import Placeholder from './src/blocks/Placeholder';

import reducer, { trackingTypes } from './src/redux/reducer';

import * as utilities from './src/utilities';
import * as constants from './src/constants';
import * as types from './src/types';

export const tracking = {
  ...trackingTypes,
  ...constants.trackingTypes,
};

export { reducer, utilities, constants, types, MultiroomWarning, Placeholder };
export default HotelsSearchForm;
